import { render, staticRenderFns } from "./BroadcastMessage.vue?vue&type=template&id=55c61bb9&scoped=true"
import script from "./BroadcastMessage.vue?vue&type=script&lang=js"
export * from "./BroadcastMessage.vue?vue&type=script&lang=js"
import style0 from "./BroadcastMessage.vue?vue&type=style&index=0&id=55c61bb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c61bb9",
  null
  
)

export default component.exports